// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2ewhw","footer":"ModalUpdate_footer__P4UNF"};